import { createComponent } from '@lit/react';
import React from 'react';
import { SDSButton } from '../sds-button/sds-button';
import { SheriffEventName } from './types';

export const SDSButtonWrapper = createComponent({
	tagName: 'sds-button',
	elementClass: SDSButton,
	react: React,
	events: {
		onClick: 'click' as SheriffEventName,
		onReset: 'reset' as SheriffEventName,
		onSubmit: 'submit' as SheriffEventName,
	},
});
